import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import Table from './Table';
import { getPaymentsReport, getAccountingReport } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress, Dialog, DialogContent } from '@material-ui/core';
import userdata from '../config/jwt_token'
import { getPaymentsReportCSVData, getAccountingReportCSVData } from './Reports';

class PaymentsReport extends Component{
    constructor(){
        super();
        this.state = {
            data: [],
            fromDate: '',
            toDate: '',
            fromDateShow: '',
            toDateShow: '',
            fromDateErr: false,
            fromDateErrText: '',
            toDateErr: false,
            toDateErrText: '',
            inProgress: false,
            snackMessage: "",
            snackOpen: false,
            validationsDialogOpen: false,
            validationErrors: [],
            dialogBoxText: "",
            showDownloadButton: false,
            paymentsReportColumns: [],
            accountingReportColumns: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitFilter = this.submitFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.generateCSV = this.generateCSV.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    componentWillMount(){
        if (userdata) {
            let role = userdata.role
            if(role !== 'City Finance' && role !== 'City Head')
                this.setState({showDownloadButton: true, paymentsReportColumns: this.props.location.state.paymentsReportColumns, accountingReportColumns: this.props.location.state.accountingReportColumns})
        }
    }
    componentDidMount(){
        this.handleFetchData()
    }

    handleChange = (props) => (event, index, value) => {
        this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
    }

    async submitFilter() {

        if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
            return
        }
        
        if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
            return
        }
        this.setState({fromDate: this.state.fromDateShow, toDate: this.state.toDateShow}, () =>
            this.handleFetchData({from_date: this.state.fromDate, to_date: this.state.toDate})
        )
    }

    handleFetchData(filters = {}){
        this.setState({ inProgress: true },() => {
            getPaymentsReport(filters).then(response => {
                if (response) {
                if (response.status === 'success') {
                    let data = response.data.map(data => {
                        return { 
                            ...data,
                            transaction_date: (data.transaction_date)?moment(data.transaction_date).format('DD-MM-YYYY hh:mm A'):data.transaction_date,
                            created_at: (data.created_at)?moment(data.created_at).format('DD-MM-YYYY hh:mm A'):data.created_at,
                            approverId1_at: (data.approverId1_at)?moment(data.approverId1_at).format('DD-MM-YYYY hh:mm A'):data.approverId1_at,
                            approverId2_at: (data.approverId2_at)?moment(data.approverId2_at).format('DD-MM-YYYY hh:mm A'):data.approverId2_at,
                        }
                    })
                    this.setState({ data, inProgress: false })
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                }
                }
            })
        })
    }


    handleCloseSnack() {
        this.setState({ snackOpen: false })
    }
    
    clearFilter() {
        this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
        this.handleFetchData();
    }

    async generateCSV() {
        let csvData = await getPaymentsReportCSVData(this.state.data);
        CSVGenerator(csvData.headers, csvData.data, csvData.filename);
    }

    generateAllCSVs() {
        let accountingReportCSVData = {};
        this.generateCSV();
        getAccountingReport({from_date: this.state.fromDate, to_date: this.state.toDate}).then(response => {
            if (response) {
                if (response.status === 'success') {
                    let accountingReportData = response.data.map(data => {
                        return { 
                            ...data,
                            transaction_date: (data.transaction_date)?moment(data.transaction_date).format('YYYY-MM-DD'):data.transaction_date,
                            payment_request_date: (data.payment_request_date)?moment(data.payment_request_date).format('YYYY-MM-DD'):data.payment_request_date,
                        }
                    })
                    this.setState({ accountingReportData });
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                }
            }
        }).then(async () => {
            accountingReportCSVData = await getAccountingReportCSVData(this.state.accountingReportData);
        }).then(() => CSVGenerator(accountingReportCSVData.headers, accountingReportCSVData.data, accountingReportCSVData.filename));
    }

    render(){
        return(
            <Fragment>
                <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Payments Report</h2>
              <p className="zaps-page-subtitle">Download and filter payment transaction records</p>
            </div>
          </div>
                <h4 style={{textAlign: 'center'}}>Details showing from {this.state.fromDate && this.state.toDate?this.state.fromDate:moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate?this.state.toDate:moment().endOf('month').format("YYYY-MM-DD")}</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div>
                    Select Transaction Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="date"
                        label="From Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.fromDateShow}
                        onChange={this.handleChange('fromDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.fromDateErr}
                        helperText={this.state.fromDateErrText}
                        margin='normal'
                    />
                    <TextField
                        id="date"
                        label="To Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.toDateShow}
                        onChange={this.handleChange('toDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.toDateErr}
                        helperText={this.state.toDateErrText}
                        margin='normal'
                    />
                    </div>
                    <div>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} onClick={this.submitFilter.bind(this)}
                        style={{ marginRight: '20px', marginTop: '25px' }}>
                        Submit Filter
                        </Button>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} onClick={this.clearFilter.bind(this)}
                        style={{ background: 'red', marginTop: '25px' }}>
                        Clear Filter
                        </Button>
                    </div>
                </div>
                <div style={{ marginTop: '25px' }} >
                {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateCSV.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download CSV
                    </Button>}
                {/* {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateAllCSVs.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download ALL
                    </Button>} */}
                </div>
    </div>
                <Table columns={this.state.paymentsReportColumns} data={this.state.data} />
                <Dialog
                open={this.state.inProgress}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        Loading...
                        <br/><br/>
                        <LinearProgress />
                    </DialogContent>
                </Dialog>
                <Snackbar
                open={this.state.snackOpen}
                message={this.state.snackMessage}
                autoHideDuration={2500}
                onClose={this.handleCloseSnack.bind(this)}
                />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
        )
    }
}

export default PaymentsReport;


// WEBPACK FOOTER //
// ./src/components/PaymentsReport.js